<template>
    <div class="CMSPage" :id="page.label">
        <div class="container">
            <div class="bg-container">
                <h2 v-html="page.title" class="page-title"></h2>
                <h4 v-html="page.subtitle" class="page-subtitle"></h4>

                <div v-html="$store.state.general.language === 'japanese' && pageJapanese.content ? pageJapanese.content : page.content"></div>
                <!-- Types
                BwPublisher\\CmsGallery
                BwPublisher\\CmsContent
                BwPublisher\\CmsAccordion -->
                <div v-if="$store.state.general.language === 'japanese' && pageJapanese">
                    <div :name="node.id" v-for="node of pageJapanese.nodes" :key="node.id">
                        <div v-for="content of node.node_contents" :key="content.id">
                            <Accordion v-if="content.contentable_type == 'BwPublisher\\CmsAccordion'" :content="content.contentable.items"/>
                            <!-- <Gallery v-if="node_contents.type == 'gallery'" :content="node_contents"/> -->
                            <!-- <Slider v-if="node_contents.type == 'slider'" :content="node_contents"/> -->
                            <Standard v-if="content.contentable_type == 'BwPublisher\\CmsContent'" :content="content.contentable"/>
                        </div>
                    </div>
                </div>
                <div v-else>
                     <div :name="node.id" v-for="node of page.nodes" :key="node.id">
                        <div v-for="content of node.node_contents" :key="content.id">
                            <Accordion v-if="content.contentable_type == 'BwPublisher\\CmsAccordion'" :content="content.contentable.items"/>
                            <!-- <Gallery v-if="node_contents.type == 'gallery'" :content="node_contents"/> -->
                            <!-- <Slider v-if="node_contents.type == 'slider'" :content="node_contents"/> -->
                            <Standard v-if="content.contentable_type == 'BwPublisher\\CmsContent'" :content="content.contentable"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import _ from 'lodash'
    import config from '../../../../config';
    import Accordion from './partials/_accordion.vue'
    import Gallery from './partials/_gallery.vue'
    import Slider from './partials/_slider.vue'
    import Standard from './partials/_standard.vue'

    export default {
        components: {
            Accordion,
            Gallery,
            Slider,
            Standard
        },
        data: function() {
            return {
                page: '',
                pageJapanese:''
            }
        },
        head: {
            title: function() {
                return {
                    inner: this.page.title
                }
            },
            meta: function () {
                return [
                    { name: 'title', content: this.page.meta_title },
                    { name: 'keywords', content: this.page.meta_keywords },
                    { name: 'description', content: this.page.meta_description }
                ]
            }
        },
        watch: {
            '$route.params': function() {
                this.formatContent()
            }
        },
        computed: {
            ...mapState({
                pages: (state) => {
                    return state.general.pages
                }
            }),
        },
        created() {
            const that = this
            _.forEach(this.pages,function(page) {
                if (page.slug == that.$route.path) {
                    page.content = page.content ? (page.content.includes(config.API_URL) ? page.content : page.content.replace(/(<img *src=")(?!http:\/\/)(.*?)"/g, '$1' + config.API_URL + '$2"')) : page.content
                    that.page = page
                }
                if (page.slug === that.$route.path + '-japanese'){
                    page.content = page.content ? (page.content.includes(config.API_URL) ? page.content : page.content.replace(/(<img *src=")(?!http:\/\/)(.*?)"/g, '$1' + config.API_URL + '$2"')) : page.content
                    that.pageJapanese = page
                }

            })
        },
        methods: {
            formatContent() {
                const that = this
                _.forEach(this.pages,function(page) {
                    if (page.slug == that.$route.path) {
                        page.content = page.content ? (page.content.includes(config.API_URL) ? page.content : page.content.replace(/(<img *src=")(?!http:\/\/)(.*?)"/g, '$1' + config.API_URL + '$2"')) : page.content
                        that.page = page
                        that.$emit('updateHead')
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    .CMSPage {
        padding: 1em 0 3em 0;

        .page-title {
            text-align: center;
        }

        p, ol, ul, dl, table {
            margin: .5em 0;
        }

        .el-collapse {
            max-width: 900px;
            margin: 0 auto;
            border: none;
        }

        .el-collapse-item__wrap {
            border-radius: 0 0 2em 2em;
        }

        .el-collapse-item__header {
            display: flex;
            font-size: 1.5em;
            line-height: 1em;
            width: 100%;
            height: auto;
            background: white !important;
            border-radius: 2em;
            padding: 1em 1.5em;
            transition: border-radius .25s ease;

            span {
                padding-right: 1em;
            }

            .el-icon-arrow-right {
                float: right;
            }

            &:hover {
                background-color: $highlight !important;
            }
        }

        .el-collapse-item {
            margin: 1em 0;

            &.is-active {
                .el-collapse-item__header {
                    border-radius: 2em 2em 0 0;
                }
            }
        }

        .el-collapse-item__content {
            padding: 1em 2em;
            font-size: initial;
        }

        &#help {
            h4 {
                margin: 0;
            }

            .Standard {
                max-width: 900px;
                margin: 0 auto;
                padding-left: 2em;
            }
        }

        @media (max-width: 767px) {
            .el-collapse-item__header {
                font-size: 1em;
            }

            .el-collapse-item {
                margin: .5em 0;
            }

            &#help {
                .Standard {
                    padding-left: 1em;
                }
            }
        }
    }
</style>